import { Field, useFormikContext } from 'formik';
import React, { FC, useRef } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import useFocusOnRouteChange from '../../hooks/useFocusOnRouteChange';
import { validateItemName } from '../../utilities/Validation';
import Label from '../label/label';
import Togglebox from '../togglebox/togglebox';

export const NotificationCard: FC = () => {
    const { errors,} = useFormikContext<any>();
    const { translate } = useLocale();
    const inputRef = useRef<HTMLInputElement>(null);

    useFocusOnRouteChange(inputRef);

    return <>
        <div className="flex flex-row w-full items-center bg-white">
            <div className="flex flex-col justify-start py-8 px-8 w-1/3">
                <div className="mb-2">
                    <div className="flex flex-row justify-between" id='nameLabelId'>
                        <Label
                            htmlFor="name"
                            className="text-xs text-gray-600 mt-1" required>
                                {translate.byKey(TranslationKeys.notificationName)}:
                        </Label>
                        {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                    </div>
                    <Field id='nameInputFieldId'
                        autoFocus
                        type="text"
                        name="name"
                        innerRef={inputRef}
                        className="flex flex-row items-center p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={(value) => validateItemName(value, translate)} 
                    />
                </div>

                <div>
                    <div className="flex flex-row justify-between" id='passwordLabelId'>
                        <Label
                            htmlFor="type"
                            className="text-xs text-gray-600 mt-1">
                                {translate.byKey(TranslationKeys.notificationType)}:
                        </Label>
                    </div>
                        <Field id='notificationType'
                            name="type"
                            type={'text'}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed"
                            disabled={true}/>
                </div>
            </div>
            <div className="flex flex-col justify-start py-8 px-8 w-1/3 self-stretch">
                <div className="mb-2">
                    <div
                        className="flex flex-row justify-between mb-1"
                        id="enabled"
                    >
                        <Label
                            htmlFor="enabled"
                            className="text-xs text-gray-600 mt-1"
                        >
                            {translate.byKey(TranslationKeys.enabled)}:
                    </Label>
                    </div>
                    <div className="flex flex-row justify-between">
                        <Togglebox name="enabled" label={""} />
                    </div>
                </div>

                <div>
                    <div className="flex flex-row justify-between" id='lastTriggered'>
                        <Label
                            htmlFor="type"
                            className="text-xs text-gray-600 mt-1">
                                {translate.byKey(TranslationKeys.lastTriggered)}:
                        </Label>
                    </div>
                        <Field id='lastTriggered'
                            name="lastTriggered"
                            type={'text'}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed"
                            disabled={true}/>
                </div>
            </div>
        </div>
    </>
}
